import React, {
  createContext,
  useRef,
  useState,
  useContext,
  useEffect,
} from "react";
import { useStateAndRef } from "../intro";

const MusicPlayerContext = createContext();

export const MusicPlayerProvider = ({ children }) => {
  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying, isPlayingRef] = useStateAndRef(false);
  const [hasMusic, setHasMusic, hasMusicRef] = useStateAndRef(false);

  useEffect(() => {
    function resetPlayback() {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
    audioRef.current.addEventListener("ended", () => resetPlayback());
    return () => {
      audioRef.current.removeEventListener("ended", () => resetPlayback());
    };
  }, []);

  const playMusic = () => {
    if (!hasMusicRef.current) {
      return;
    }
    audioRef.current.play();
    setIsPlaying(true);
  };

  const pauseMusic = () => {
    audioRef.current.pause();
    setIsPlaying(false);
  };

  const toggleMusic = () => {
    isPlayingRef.current ? pauseMusic() : playMusic();
  };

  const setMusicURL = (url) => {
    if (audioRef.current.src === url) {
      return;
    }
    var autoPlay = false;
    if (isPlayingRef.current) {
      pauseMusic();
      autoPlay = true;
    }
    audioRef.current.src = url;

    const hasSrc = url !== undefined && url !== null && url !== "";
    setHasMusic(hasSrc);

    if (autoPlay && hasSrc) {
      playMusic();
    }
  };

  return (
    <MusicPlayerContext.Provider
      value={{
        hasMusic,
        playMusic,
        pauseMusic,
        toggleMusic,
        setMusicURL,
        isPlaying,
      }}
    >
      {children}
    </MusicPlayerContext.Provider>
  );
};

export const useMusicPlayer = () => useContext(MusicPlayerContext);
